const env = process.env.NODE_ENV;
const config = {
  onlineEnv: env === 'production',
  reSiteKey: ['6', 'L', 'f', 'G', 'f', 'Y', 'w', 'q', 'A', 'A', 'A', 'A', 'A', 'B', 'D', 's', 'H', 'B', 'z', 'Z', 'b', 'w', '3', 'u', 'x', 'l', 'R', 'F', 'h', 't', 'X', 's', '0', 'j', 'y', 'Z', 'Z', 'm', 'p', '4']
}
export default config;